<div class="container mx-auto p-8">
  <form [formGroup]="form" (ngSubmit)="onSubmit()">
    <h4 class="!text-[24px] !font-semibold !text-[#203D54]">Insurance</h4>
    <!-- Insurance Section -->

    <!-- insurance Section -->
    <div class="section-color p-6 mb-8">
      <h2 class="text-xl section-title">Insurance</h2>
      <div class="mb-4">
        <label for="insuranceTitle" class="block section-label-sm">Title</label>
        <input
          type="text"
          id="insuranceTitle"
          formControlName="insuranceTitle"
          class="mt-1 p-2 block w-full section-input sm:text-sm"
          placeholder="Enter Title"
        />
        <div
          *ngIf="
            form.get('insuranceTitle')?.touched &&
            form.get('insuranceTitle')?.invalid
          "
        >
          <span
            *ngIf="form.get('insuranceTitle')?.errors?.['required']"
            class="text-red-500 text-sm"
          >
            Title is required
          </span>
        </div>
      </div>
      <div class="mb-4">
        <label for="insuranceDescription" class="block section-label-sm"
          >Description</label
        >

        <textarea
          id="insuranceDescription"
          formControlName="insuranceDescription"
          rows="6"
          class="mt-1 p-2 block w-full section-input sm:text-sm"
          placeholder="Enter Description"
        ></textarea>
      </div>
      <div class="mb-4">
        <label for="insuranceFile" class="block section-label-sm"
          >Attach Documents</label
        >
        <input
          type="file"
          id="insuranceFile"
          (change)="onFileUpload($event)"
          class="mt-1 block w-full text-sm text-gray-900 border border-gray-300 rounded-md cursor-pointer focus:outline-none"
        />
        <div *ngIf="showFileError" class="text-red-500 text-sm">
          File is required.
        </div>
      </div>
    </div>

    <!-- Buttons -->
    <div class="flex justify-end">
      <button
        type="button"
        class="bg-gray-300 hover:bg-gray-400 text-gray-800 font-bold py-2 px-4 rounded inline-flex items-center mr-[12px]"
      >
        Back
      </button>
      <button
        type="submit"
        class="bg-blue-500 hover:bg-blue-700 text-white font-bold py-2 px-4 rounded inline-flex items-center"
      >
        Save
      </button>
    </div>
  </form>
</div>
